import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../CommonComponents/CommonCardHeader/CommonCardHeader'
import { OffcanvasVariationsTitle } from '../../../../Constants/Constants'
import { OffcanvasVariationsSubTitle } from '../../../../Data/UiKits/Offcanvas'
import LeftRightOffcanvas from '../OffcanvasDirections/LeftRightOffcanvas'

const OffcanvasVariations = () => {
  return (
    <Col xs="12">
    <Card>
      <CommonCardHeader title={OffcanvasVariationsTitle} span={OffcanvasVariationsSubTitle} />
      <CardBody className="common-flex common-offcanvas">
        <LeftRightOffcanvas title={"Offcanvas body scrolling"} direction={"start"} color="info" data/>
        <LeftRightOffcanvas title={"Enable Both Scrolling & Backdrop"} direction={"start"} color="warning" data/>
        <LeftRightOffcanvas title={"Toggle Static Offcanvas"} direction={"start"} color="info" data/>
      </CardBody>
    </Card>
  </Col>
  )
}

export default OffcanvasVariations